import { MessageCircle } from "lucide-react";
import { useLanguage } from "../../contexts/LanguageContext";

export const FloatingWhatsApp = () => {
  const { language, translations: t } = useLanguage();
  
  return (
    <a
      href="https://wa.me/972523824500"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-24 md:bottom-8 right-6 z-[9999] group"
      data-testid="floating-whatsapp"
      aria-label={language === 'he' ? "שלחי הודעה בוואטסאפ" : "Send WhatsApp message"}
    >
      <div className="relative">
        <div className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-25" />
        <div className="relative w-16 h-16 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-lg hover:scale-110 hover:shadow-xl transition-all">
          <MessageCircle className="w-8 h-8" />
        </div>
        <div className="absolute bottom-full right-0 mb-2 px-3 py-2 bg-[#2C2C2C] text-white text-sm rounded-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
          {t.contact.info.whatsappText}
        </div>
      </div>
    </a>
  );
};
